"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconSleepTimer = Experimental__IconSleepTimer;
exports.IconSleepTimer = IconSleepTimer;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconSleepTimer is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconSleepTimer(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'m7.85 1.93.932-1.96-2.095.564a7.614 7.614 0 1 0 8.05 11.954l1.313-1.726-2.165.123A6.275 6.275 0 0 1 7.85 1.93z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'m10.964 2.71.932-1.96-2.095.565C5.117 2.577 1.669 6.853 1.669 11.937c0 6.075 4.925 11 11 11 3.577 0 6.756-1.709 8.763-4.35l1.312-1.727-2.165.123A10.12 10.12 0 0 1 20 17c-5.523 0-10-4.477-10-10 0-1.537.346-2.991.964-4.29z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconSleepTimer is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconSleepTimer(props) {
  return /*#__PURE__*/_react["default"].createElement(IconSleepTimer, props);
}